import {
  PatientBirthSexId,
  PhoneNumberTypeId
} from './patient.interface'

import type {
  IPatientPhoneNumber,
  IPatientEmailAddress,
  IPatientContactInformation} from './patient.interface';

const patientBirthSexShortLabel: { [key in PatientBirthSexId]: string } = {
  [PatientBirthSexId.Female]: 'F',
  [PatientBirthSexId.Male]: 'M',
  [PatientBirthSexId.Other]: 'O',
  [PatientBirthSexId.Unknown]: 'U',
}

export const getPatientBirthSexShortLabel = (
  patient: { birthSex?: PatientBirthSexId },
  unknownLabel = '–',
) =>
  patient.birthSex
    ? patientBirthSexShortLabel[patient.birthSex] || unknownLabel
    : unknownLabel

const patientBirthSexLabel: { [key in PatientBirthSexId]: string } = {
  [PatientBirthSexId.Female]: 'Female',
  [PatientBirthSexId.Male]: 'Male',
  [PatientBirthSexId.Other]: 'Other',
  [PatientBirthSexId.Unknown]: 'Unknown',
}

export const getBirthSexLabel = (birthSex?: PatientBirthSexId) =>
  birthSex ? patientBirthSexLabel[birthSex] ?? '–' : '-'

export const getPatientBirthSexLabel = (patient: {
  birthSex?: PatientBirthSexId
}) => getBirthSexLabel(patient.birthSex)

export const getPhoneTypeLabelFromTypeId = (phoneTypeId: PhoneNumberTypeId) => {
  switch (phoneTypeId) {
    case PhoneNumberTypeId.null:
      return ''

    case PhoneNumberTypeId.Mobile:
      return 'Mobile'

    case PhoneNumberTypeId.Landline:
      return 'Landline'
  }
}

export const getPhoneTypeLabel = (phoneTypeId: PhoneNumberTypeId) =>
  getPhoneTypeLabelFromTypeId(phoneTypeId)

export const emailAddressFromPatient = (
  contactInformation: IPatientContactInformation,
): IPatientEmailAddress =>
  'emailAddress' in contactInformation && contactInformation.emailAddress

export const phoneNumberFromPatient = (
  contactInformation: IPatientContactInformation,
): IPatientPhoneNumber =>
  'phoneNumber' in contactInformation && contactInformation.phoneNumber

export const phoneNumberTypePatient = (
  contactInformation: IPatientContactInformation,
): PhoneNumberTypeId =>
  'phoneNumberType' in contactInformation && contactInformation.phoneNumberType
